import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=20b6a72e&scoped=true&"
import script from "./DocumentPage.vue?vue&type=script&lang=js&"
export * from "./DocumentPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPage.vue?vue&type=style&index=0&id=20b6a72e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6a72e",
  null
  
)

export default component.exports